import { RouteLocationRaw } from 'vue-router';
import { PublicationSessionStorageCommon } from './publication-session-storage.common';

/**
 * Where the publications overview stood when the reader last left it, filter and page included.
 *
 * The overview keeps its search filter in its own query string. Rather than copying that filter onto
 * the detail and version pages — where those values mean nothing — the overview records its own URL,
 * and the link back reads it. It lives in session storage, so it survives a refresh and is private to
 * the tab, but it does not travel: a detail page opened in a second tab, or from a shared link, has no
 * overview to return to and falls back to the bare one.
 */
const OVERVIEW_KEY = 'overviewUrl';

export function rememberOverview(fullPath: string): void {
    try {
        PublicationSessionStorageCommon.set(OVERVIEW_KEY, fullPath);
    } catch {
        // Storage can be unavailable or full. Remembering the way back is a convenience, never a
        // reason to break the page.
    }
}

/**
 * The overview to return to, or `fallback` when none was recorded.
 *
 * Only an in-app path is accepted: anything else means the value was tampered with, and a link that
 * reads "Publicaties" should never lead off-site.
 */
export function overviewLocation(fallback: RouteLocationRaw): RouteLocationRaw {
    let remembered: unknown;

    try {
        remembered = PublicationSessionStorageCommon.get(OVERVIEW_KEY);
    } catch {
        return fallback;
    }

    if (typeof remembered === 'string' && remembered.startsWith('/') && !remembered.startsWith('//')) {
        return remembered;
    }

    return fallback;
}
